import { NgModule,
    Component }                 from '@angular/core';
import { NavController,
    IonicApp,
    IonicModule}                from 'ionic-angular';
import { ViewChild }            from    '@angular/core';
import { Platform }             from 'ionic-angular';
import {FaceBookService}        from '../../providers/facebook-provider';
import {FirebaseService}        from '../../providers/firebase-provider';

declare var window: any;

@Component({
    selector: 'logout',
    templateUrl: 'logout.page.html'
})
export class logoutComponent {

    constructor(
        private platform: Platform,
        private faceBookService: FaceBookService,
        private firebaseService: FirebaseService
    ) {
    }
    logout() {
        this.firebaseService.logout();
    }
}



// WEBPACK FOOTER //
// ./src/app/feature/loginModule/pages/logout/logout.page.ts